<template>
  <div class="d-flex flex-column justify-center align-center">
    <p class="h6 mb-4 blue-grey--text text--darken-3">
      {{ roundedPercentage }}%
    </p>
    <v-progress-linear class="ma-0 pa-0" color="blue" :value="progress" />

    <span class="font-size-10 blue-grey--text text--darken-2 py-2"
      >{{ $t('excel.importing_items') }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },

  computed: {
    roundedPercentage() {
      return Math.round(this.progress)
    },
  },
}
</script>
